// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"ErrorPage_ErrorPage__2xSeE","Title":"ErrorPage_Title__5iQgs","LinkToMain":"ErrorPage_LinkToMain__2OvAR"};